import { Select, SelectProps } from "@mantine/core"

const CustomSelect = (props: SelectProps) => {
  return (
    <Select
      labelProps={{
        size: 'sm',
        mb: 2,
      }}
      mb={6}
      withAsterisk={props.required}
      {...props}
    />
  )
}

export default CustomSelect;